import Api from '@/services/Api.js';
import { isEmpty } from 'lodash';
import {setHttpToken} from '@/helpers/index.js';
import localforage from 'localforage';

const state = {
	user: {
		authenticated: false,
		data: null
	},
	role: ''
};

const getters = {
	user: (state) => state.user
};

const actions = {
	// Authorize Wordpress Access Token
	wpAuthorize({ commit }, credentials) {
		return new Promise((resolve, reject) => {
			//commit("auth_request");
			Api.post("wp/token/validate", {
				hash: credentials.hash,
				access_token: credentials.access_token
			})
				.then(resp => {
					const token = `Bearer ${resp.data.meta.token}`;
					const user = resp.data.data.user;
					localStorage.setItem("token", token);
					Api.defaults.headers.common["Authorization"] = token;
					//commit("auth_success", token, user);
					resolve(resp);
				})
				.catch(err => {
					//commit("auth_error");
					localforage.removeItem("token");
					reject(err);
				});
		});
	},
	// Password Reset
	SEND_PASSWORD_RESET_LINK({}, data) {
		return new Promise((resolve, reject) => {
			Api.post("password/email", data)
				.then(response => resolve({success: true}))
				.catch(error => reject({ success: false, data: error.response.data.errors }));
		});
	},
	RESET_PASSWORD({}, data) {
		return new Promise((resolve, reject) => {
			Api.post("password/reset", data)
				.then(response => {
					if(response.status === 202) {
						reject({success: false, data: { token: 'This password reset token is invalid.' }});
					}
					resolve({ success: true });
				})
				.catch(error => reject({ success: false, data: error.response.data.errors }));
		});
	},
	// Login
	login({dispatch, commit}, {payload, context}) {
		return Api.post('/login', payload).then((response) => {
			dispatch('setToken', response.data.meta.token).then(() => {
				dispatch('fetchUser')
				return Promise.resolve('LOGGED_IN');
			})
			return Promise.resolve({ token:  response.data.meta.token});
		}).catch((error) => {
			context.errors = error.response.data.errors;
			return Promise.reject('LOGIN_FAILED');
		});
	},
    async fetchUser ({commit}) {
		const token = await localforage.getItem('authtoken');
		if( isEmpty(token) ) {
			return Promise.reject('NO_STORAGE_TOKEN');
		}
		setHttpToken(token)
		commit('setToken', token)

		return await Api.get('/api/me').then((response) => {
			commit('setAuthenticated', true)
			commit('setUserData', response.data.data)
			commit('setRole', response.data.data.roles.find(role => ['wemail_admin', 'wemail_developer', 'wemail_analyst'].includes(role.slug)).slug)
		})
	},
	// Logout
    logout({dispatch}, data = {}) {
		Api.post('/logout').then((response) => {
			if (data.path || data.type) {
				if (data.path) {
					localforage.setItem('intended', data.path);
				}
				localforage.setItem('alert', { type: data.type, msg: data.msg });
			}
			dispatch('clearAuth');
			return Promise.resolve('LOGGED_OUT');
		}).catch(err => Promise.reject('LOGGED_OUT_ERROR'));
	},
    async setToken({commit, dispatch}, token) {
		if( isEmpty(token) ) {
			return await dispatch('checkTokenExists').then((token) => {
				setHttpToken(token);
			})
		}
		commit('setToken', token)
		setHttpToken(token)
	},
    checkTokenExists() {
		return localforage.getItem('authtoken').then((token)=>{
			if( isEmpty(token) ) {
				return Promise.reject('NO_STORAGE_TOKEN');
			}
			return Promise.resolve(token)
		})
	},
    clearAuth({commit}) {
		commit('setAuthenticated', false);
		commit('setUserData', null);
		commit('setToken', null);
		setHttpToken(null);
	}
};

const mutations = {
	setToken(state, token) {
		if(isEmpty(token)) {
			localforage.removeItem('authtoken', token)
			return;
		}
		localforage.setItem('authtoken', token)
	},
	setAuthenticated(state, trueOrFalse) {
		state.user.authenticated = trueOrFalse
	},
	setUserData(state, data) {
		state.user.data = data
	},
	setRole(state, data) {
		state.role = data
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
